// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/payment.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { CapturePaymentRequest, ConfigurePaymentMethodRequest, CreatePaymentSessionRequest, CreatePaymentSessionResponse, DeletePaymentMethodRequest, GetPaymentStatusRequest, GetTransactionRequest, ListPaymentMethodsRequest, ListPaymentMethodsResponse, ListTransactionsRequest, ListTransactionsResponse, PaymentMethodConfig, PaymentTransaction, RefundPaymentRequest, UpdatePaymentMethodRequest } from "./payment_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.PaymentService
 */
export const PaymentService = {
  typeName: "omnios.v1.PaymentService",
  methods: {
    /**
     * Payment method configuration
     *
     * @generated from rpc omnios.v1.PaymentService.ConfigurePaymentMethod
     */
    configurePaymentMethod: {
      name: "ConfigurePaymentMethod",
      I: ConfigurePaymentMethodRequest,
      O: PaymentMethodConfig,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PaymentService.UpdatePaymentMethod
     */
    updatePaymentMethod: {
      name: "UpdatePaymentMethod",
      I: UpdatePaymentMethodRequest,
      O: PaymentMethodConfig,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PaymentService.DeletePaymentMethod
     */
    deletePaymentMethod: {
      name: "DeletePaymentMethod",
      I: DeletePaymentMethodRequest,
      O: PaymentMethodConfig,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PaymentService.ListPaymentMethods
     */
    listPaymentMethods: {
      name: "ListPaymentMethods",
      I: ListPaymentMethodsRequest,
      O: ListPaymentMethodsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * Payment operations (via WASM plugins)
     *
     * @generated from rpc omnios.v1.PaymentService.CreatePaymentSession
     */
    createPaymentSession: {
      name: "CreatePaymentSession",
      I: CreatePaymentSessionRequest,
      O: CreatePaymentSessionResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PaymentService.CapturePayment
     */
    capturePayment: {
      name: "CapturePayment",
      I: CapturePaymentRequest,
      O: PaymentTransaction,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PaymentService.RefundPayment
     */
    refundPayment: {
      name: "RefundPayment",
      I: RefundPaymentRequest,
      O: PaymentTransaction,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PaymentService.GetPaymentStatus
     */
    getPaymentStatus: {
      name: "GetPaymentStatus",
      I: GetPaymentStatusRequest,
      O: PaymentTransaction,
      kind: MethodKind.Unary,
    },
    /**
     * Transaction queries
     *
     * @generated from rpc omnios.v1.PaymentService.ListTransactions
     */
    listTransactions: {
      name: "ListTransactions",
      I: ListTransactionsRequest,
      O: ListTransactionsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.PaymentService.GetTransaction
     */
    getTransaction: {
      name: "GetTransaction",
      I: GetTransactionRequest,
      O: PaymentTransaction,
      kind: MethodKind.Unary,
    },
  }
};

